<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/setup/withdrawalLimit")
          i.fas.fa-landmark
          span.ml-1 {{ $t("ui.withdrawal_limit") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row.col-md-12
            div(width="60%").mr-3
              b-button(v-b-modal.addWithdrawalLimit type="button" variant="primary" size="sm").mr-3
                i.fa.fa-plus
                span {{ $t("ui.combine.add_withdrawal_limit") }}
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 60%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.limit_id')") {{ $t('ui.limit_id') }}
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.limit_name')") {{ $t("ui.limit_name") }}
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.daily_amount')") {{ $t("ui.daily_amount") }}
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.daily_frequency')") {{ $t("ui.daily_frequency") }}
                      th.text-center.sticky-position(width="9%")
                        span(:title="$t('ui.is_default')") {{ $t("ui.is_default") }}
                      th.text-center.sticky-position(width="9%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                      th.text-right.sticky-position(width="10%")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  tbody.clusterize-content
                    tr(v-if="withdrawalLimitList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in withdrawalLimitList")
                      td
                        span(:title="index + 1") {{ index + 1 }}
                      td
                        span(:title="item.limit_id") {{ item.limit_id }}
                      td
                        span(:title="item.limit_name") {{ item.limit_name }}
                      td
                        span(:title="$n(item.daily_amount, 'currency')") {{ $n(item.daily_amount, 'currency') }}
                      td
                        span(:title="$n(item.daily_frequency, 'integer')") {{ $n(item.daily_frequency, 'integer') }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.is_default, 'fas fa-times text-warning': !item.is_default  }")
                      td.actions
                        span
                          a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                        span(v-if="!item.is_default")
                          a.fa.fa-flag.text-warning(href="javascript:void(0)" @click="onDefault(item)" :title="$t('ui.set_default')")
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    addwithdrawallimit(@clicked="addWithdrawalLimit" @failed="handleFailed")
    editwithdrawallimit(ref="editwithdrawallimit" :item="editSelectedLimit" @clicked="afterEditLimit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addwithdrawallimit from "@/components/setup/addWithdrawalLimit.vue";
import editwithdrawallimit from "@/components/setup/editWithdrawalLimit.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editwithdrawallimit,
    addwithdrawallimit
  },
  data: () => ({
    loading: false,
    withdrawalLimitList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedLimit: null,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  mounted: function() {
    this.getWithdrawalLimit();
  },
  methods: {
    addWithdrawalLimit: function() {
      this.getWithdrawalLimit();

      this.$helpers.showDialog(this.$t("ui.combine.add_withdrawal_limit"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedLimit = e;
      this.$refs.editwithdrawallimit.$refs.editWithdrawalLimit.show();
    },
    afterEditLimit: function(item) {
      this.getWithdrawalLimit();
      this.$helpers.showDialog(this.$t("ui.combine.edit_withdrawal_limit"), this.$t("message.success"), "success");
    },
    getWithdrawalLimit: function() {
      let url = config.withdrawalLimitListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalLimitList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDefault: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.set_default"),
          text: this.$t("message.change_withdrawal_limit_default_confirm", { name: item.limit_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmWithdrawalLimitDefault(item);
          }
        });
    },
    confirmWithdrawalLimitDefault: function(item, status) {
      let url = config.withdrawalLimitDefaultUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        limit_id: item.limit_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getWithdrawalLimit();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
